import { useState, useEffect, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import api from './api';

export const useAuth = () => {
    const [token, setToken] = useState(localStorage.getItem('authToken'));
    const [user, setUser] = useState(null);
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    const [loading, setLoading] = useState(true); // Add loading state

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    const updateUserTheme = useCallback(async (newTheme) => {
        setTheme(newTheme);
        try {
            await api.put('/api/users/theme', { theme: newTheme });
        } catch (error) {
            console.error("Failed to update theme on server:", error);
            // Optionally revert theme if server update fails
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        if (token) {
            try {
                // Set the token for all future requests
                api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                
                const decoded = jwtDecode(token);
                setUser({
                    username: decoded.sub,
                    role: decoded.role,
                    fullName: decoded.full_name,
                    firstName: decoded.full_name?.split(' ')[0],
                    theme: decoded.theme
                });
                setTheme(decoded.theme || 'light');
                localStorage.setItem('authToken', token);
            } catch (error) {
                console.error("Invalid token:", error);
                setUser(null);
                delete api.defaults.headers.common['Authorization'];
                localStorage.removeItem('authToken');
            }
        } else {
            setUser(null);
            delete api.defaults.headers.common['Authorization'];
            localStorage.removeItem('authToken');
        }
        setLoading(false); // Finished loading
    }, [token]);

    const login = (newToken) => {
        const decoded = jwtDecode(newToken);
        setTheme(decoded.theme || 'light');
        setToken(newToken);
    };

    const logout = () => {
        setToken(null);
    };

    return { token, user, loading, login, logout, theme, updateUserTheme };
};
